// Central icon service. The rest of the app should ONLY import icons from here.
// When we replace lucide-react with our own icon set, this is the only file
// that needs to change.

import { Car, Store, type LucideIcon } from 'lucide-react';

export type IconComponent = React.ComponentType<{
  className?: string;
  size?: number | string;
}>;

const wrap = (Icon: LucideIcon): IconComponent => Icon;

export const Icons = {
  pickup: wrap(Store),
  dropoff: wrap(Car),
} as const;

export type IconName = keyof typeof Icons;

// Helper for fulfillmentMethod[] → icon list
import type { FulfillmentMethod } from '../types/listing';

export type FulfillmentIconMeta = {
  method: FulfillmentMethod;
  /** aria-label only, never rendered as visible text. Hardcoded English like
   *  the pickup entry it sits beside — this predates drop-off and should move
   *  to the `orders:card.fulfillment.<method>` keys the pickers already use. */
  label: 'Pickup' | 'Dropoff';
  Icon: IconComponent;
};

export const getFulfillmentIcons = (
  methods: FulfillmentMethod[] | null | undefined,
): FulfillmentIconMeta[] => {
  if (!methods || methods.length === 0) return [];
  const out: FulfillmentIconMeta[] = [];
  if (methods.includes('pickup')) {
    out.push({ method: 'pickup', label: 'Pickup', Icon: Icons.pickup });
  }
  if (methods.includes('dropoff')) {
    out.push({ method: 'dropoff', label: 'Dropoff', Icon: Icons.dropoff });
  }
  return out;
};
